import { useEffect, useState } from "react";
import client from "../lib/api";

const EMPTY = { zones: [], areas: [], document_types: [] };
let cache = null;

// Zones/quarters/areas catalog. Pass `publicData` (from /submit/{token}) to skip the authed call.
export function useLocations(publicData) {
  const [data, setData] = useState(publicData || cache || EMPTY);
  useEffect(() => {
    if (publicData) { setData(publicData); return; }
    if (cache) return;
    client.get("/locations").then((r) => { cache = r.data; setData(r.data); }).catch(() => {});
  }, [publicData]);
  const quarters = data.zones.flatMap((z) => z.quarters.map((q) => ({ ...q, zone: z.name })));
  return {
    ...data,
    quarters,
    quarterName: (id) => quarters.find((q) => q.id === id)?.name || "",
    areaName: (id) => data.areas.find((a) => a.id === id)?.name || "",
    refresh: () => client.get("/locations").then((r) => { cache = r.data; setData(r.data); }),
  };
}
